import {
  LOAD_SEASONS,
  LOADING_METADATA,
  METADATA_FAILED,
  METADATA_LOADED,
  RESET_SEASONS,
  SEASONS_FAILED,
  SEASONS_LOADED,
} from './actionTypes';
import type { ISeedMetadataState } from './types';

export const initialState = {
  seasons: {
    loaded: false,
    loading: false,
    error: null,
    data: [],
  },
  config: {
    loaded: false,
    loading: false,
    error: null,
    data: {
      seedTypes: [],
      paymentTerms: [],
    },
  },
};

export const reducer = (
  state: ISeedMetadataState = initialState,
  action: { type: any; payload?: any },
): ISeedMetadataState => {
  switch (action.type) {
    case LOAD_SEASONS:
      return {
        ...state,
        seasons: {
          ...state.seasons,
          loading: true,
          error: null,
        },
      };
    case SEASONS_LOADED:
      return {
        ...state,
        seasons: {
          ...state.seasons,
          loading: false,
          loaded: true,
          data: action.payload,
        },
      };
    case SEASONS_FAILED:
      return {
        ...state,
        seasons: {
          ...state.seasons,
          loading: false,
          error: action.payload,
        },
      };
    case RESET_SEASONS: {
      return {
        ...state,
        seasons: initialState.seasons,
      };
    }
    case LOADING_METADATA: {
      return {
        ...state,
        config: {
          ...state.config,
          loading: true,
          error: null,
        },
      };
    }
    case METADATA_LOADED: {
      return {
        ...state,
        config: {
          ...state.config,
          loading: false,
          loaded: true,
          data: action.payload,
        },
      };
    }
    case METADATA_FAILED: {
      return {
        ...state,
        config: {
          ...state.config,
          loading: false,
          error: action.payload,
        },
      };
    }
    default:
      return state;
  }
};
